<template>
  <hr class="border-[#878787]" />
  <div id="siteMap" class="w-full pt-10 font-jost flex flex-col" style="padding-left: 10%">
    <div id="siteMapContent" class="text-button-brown text-lg flex flex-col w-full">
      <div id="siteMapContentTop" class="flex" style="height: 25%">
        <div id="siteMapCorporate" style="width: 20%">
          <div class="font-bold pb-6">
            <span class="cursor-default">{{ t("sitemap.corporate") }}</span>
          </div>
          <template v-for="(item, index) in siteMap('Corporate').itemList" :key="'siteMapItem' + index">
            <div><router-link class="cursor-pointer" :to="routeToSection(item)">{{ t(item) }}</router-link></div>
            <!-- <div @click="routeToSection('corporate', item)" class="cursor-pointer"> {{ t(item) }} </div> -->
          </template>
        </div>
        <div id="siteMapInsurer" style="width: 20%">
          <div class="font-bold pb-6">
            <span class="cursor-default">{{ t("sitemap.insurer") }}</span>
          </div>
          <template v-for="(item, index) in siteMap('Insurer').itemList" :key="'siteMapItem' + index">
            <div><router-link class="cursor-pointer" :to="routeToSection(item)">{{ t(item) }}</router-link></div>
            <!-- <div @click="routeToSection('insurer', item)" class="cursor-pointer">{{ t(item) }}</div> -->
          </template>
        </div>
        <div id="siteMapPatient" style="width: 20%">
          <div class="font-bold pb-6">
            <span class="cursor-default">{{ t("sitemap.patient") }}</span>
          </div>
          <template v-for="(item, index) in siteMap('Patient').itemList" :key="'siteMapItem' + index">
            <div><router-link class="cursor-pointer" :to="routeToSection(item)">{{ t(item) }}</router-link></div>
            <!-- <div @click="routeToSection('patients', item)" class="cursor-pointer">{{ t(item) }}</div> -->
          </template>
        </div>
        <div id="siteMapServices" style="width: 20%">
          <div class="font-bold pb-6">
            <span class="cursor-default">{{ t("sitemap.services") }}</span>
          </div>
          <template v-for="(item, index) in siteMap('Services').itemList" :key="'siteMapItem' + index">
            <div><router-link class="cursor-pointer" :to="routeToSection(item)">{{ t(item) }}</router-link></div>
            <!-- <div @click="routeToSection('services', item)" class="cursor-pointer">{{ t(item) }}</div> -->
          </template>
        </div>

        <!-- <div id="siteMapAboutUs" style="width: 20%">
          <div class="font-bold pb-6">
            <span class="cursor-default">{{ t("sitemap.aboutus") }}</span>
          </div>
          <template v-for="(item, index) in siteMap('About Us').itemList" :key="'siteMapItem' + index">
            <div @click="routeToSection('aboutus', item)" class="cursor-default">{{ t(item) }}</div>
          </template>
        </div> -->

      </div>
      <div id="siteMapContentMiddle" class="flex pt-10" style="height: 25%">
        
        <!-- <div id="siteMapInvestorRelations" style="width: 20%">
          <div class="font-bold pb-6 cursor-default">{{ t("sitemap.investorrelation") }}</div>
          <template v-for="(item, index) in siteMap('Investor Relations').itemList" :key="'siteMapItem' + index">
            <div class="cursor-default">{{ t(item) }}</div>
          </template>
        </div> -->

        <div id="siteMapWorkWUs" style="width: 20%">
          <div class="font-bold pb-6 cursor-default">{{ t("sitemap.workWithUs") }}</div>
          <template v-for="(item, index) in siteMap('Work With Us').itemList" :key="'siteMapItem' + index">
            <div><router-link class="cursor-pointer" :to="routeToSection(item)">{{ t(item) }}</router-link></div>
            <!-- <div @click="routeToSection('corporate', item)" class="cursor-pointer">{{ t(item) }}</div> -->
          </template>
        </div>

        <div id="siteMapBookUrAppointment" style="width: 20%">
          <div class="font-bold pb-6 cursor-default">{{ t("sitemap.bookUrAppoint") }}</div>
          <template v-for="(item, index) in siteMap('Book Your Appointment').itemList" :key="'siteMapItem' + index">
            <div><router-link class="cursor-pointer" :to="routeToSection(item)">{{ t(item) }}</router-link></div>
            <!-- <div @click="routeToSection('corporate', item)" class="cursor-pointer">{{ t(item) }}</div> -->
          </template>
        </div>

        <div id="siteMapCorporateMemberLogin" style="width: 20%">
          <div class="font-bold pb-6 cursor-default">{{ t("sitemap.corporateMemberLogin") }}</div>
          <template v-for="(item, index) in siteMap('Corporate Member Login').itemList" :key="'siteMapItem' + index">
            <div><router-link class="cursor-pointer" :to="routeToSection(item)">{{ t(item) }}</router-link></div>
            <!-- <div>{{ t(item) }}</div> -->
          </template>
        </div>
      </div>
    </div>

    <div id="sitMapCompanyInfo" class="pt-20 text-lg flex w-full">
      <div id="siteMapCompanyInfoDetail" style="width: 60%">
        <div class="flex w-full flex-row">
          <div class="w-full">
            <div class="pr-20 pb-5"> {{ t("sitemap.address") }} </div>
            <div>
              <span class="inline-block w-14">{{ t("sitemap.tel") }}:</span>
              <span class="underline decoration-1 text-links">+852 3723 3063</span>
            </div>
            <div>
              <span class="inline-block w-14">{{ t("sitemap.fax") }}:</span>
              <span class="">+852 8343 1958</span>
            </div>
            <div>
              <span class="inline-block w-14">{{ t("sitemap.email") }}:</span>
              <span>info@the-hk.com</span>
            </div>
          </div>
        </div>
      </div>

      <!-- <div id="siteMapCompanyInfoEmailBox" style="width: 30%">
        <div class="text-sm" v-html="t('sitemap.newsletter')" />
        <input v-model="footerStore.email" :placeholder="t('sitemap.emailAddress')" class="placeholder:text-button-brown px-3 h-14 bg-[#F6F5F5] border-none mt-5 mb-4 w-full" />
        <button-util buttonType="button" bgColor="#603813" label="Subscribe" @click="routeTo('comingsoon')" />
      </div> -->
    </div>

    <div id="siteMapFooter" class="pt-10" style="padding-right: 10%">
      <img src="@/assets/images/footer/in.svg" style="width: 1.3vw" />
      <hr class="mt-6 mb-4 border-button-brown" />
      <div class="text-button-brown text-sm">
        {{ t("sitemap.trinityRights") }}
        <span class="underline decoration-1 cursor-pointer ml-3">{{ t("sitemap.privacypolicy") }}</span>
        <span class="underline decoration-1 cursor-pointer ml-3">{{ t("sitemap.termsOfUse") }}</span>
        <span class="underline decoration-1 cursor-pointer ml-3">{{ t("sitemap.cookiesPolicy") }}</span>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, onMounted, ref, toRefs } from "vue";
import { useRouter } from "vue-router";
import { useFooterStore } from "@/stores/footer";
import { useI18n } from "vue-i18n";
import { useCommonStore } from "@/stores/common";
import moment from "moment";

const router = useRouter();
const footerStore = useFooterStore();
const commonStore = useCommonStore();
const { t, locale } = useI18n();

const siteMap = (title) => {
  return footerStore.siteMapList.find((element) => element.title == title);
};

const routeTo = (position) => {
  router.push({ name: position, params: { uid: "lczmx" } });
};

const routeToSection = (item) => {

  switch (item) {
    // corporate
    case 'sitemap.aboutcorporate':
      return { path: '/aboutcorporate', hash: '#aboutCor' }
    case 'sitemap.healthSolutions':
      return { path: '/aboutcorporate', hash: '#healthSol' }
    case 'sitemap.preventWell':
      return { path: '/aboutcorporate', hash: '#preventWel' }
    case 'sitemap.healthAnalytics':
      return { path: '/aboutcorporate', hash: '#healthAna' }
    case 'sitemap.employHealthMan':
      return { path: '/aboutcorporate', hash: '#employHea' }
    case 'sitemap.medicalAdvis':
      return { path: '/aboutcorporate', hash: '#medicalAdv' }

    // insurer
    case 'sitemap.aboutinsurer':
      return { path: '/aboutinsurer', hash: '#aboutIns' }
    case 'sitemap.networkDoctors':
      return { path: '/aboutinsurer', hash: '#networkDoc' }
    case 'sitemap.costContain':
      return { path: '/aboutinsurer', hash: '#costCon' }
    case 'sitemap.callCenterServices':
      return { path: '/aboutinsurer', hash: '#callCen' }
    
    // patient
    case 'sitemap.aboutpatients':
      return { path: '/aboutpatients', hash: '#aboutPat' }
    case 'sitemap.patientExp':
      return { path: '/aboutpatients', hash: '#patientExp' }
    case 'sitemap.healthOptim':
      return { path: '/aboutpatients', hash: '#healthOpt' }
    case 'sitemap.diseaseMan':
      return { path: '/aboutpatients', hash: '#diseaseMan' }
    case 'sitemap.doctorRef':
      return { path: '/aboutpatients', hash: '#doctorRef' }
    case 'sitemap.homeCare':
      return { path: '/aboutpatients', hash: '#homeCar' }

    // services
    case 'sitemap.aboutservices':
      return { path: '/aboutservices', hash: '#aboutSer' }
    case 'sitemap.corporatePack':
      return { path: '/aboutservices', hash: '#corporatePac' }
    case 'sitemap.advisory':
      return { path: '/aboutservices', hash: '#advisory' }
    case 'sitemap.checkupServe':
      return { path: '/aboutservices', hash: '#checkupSer' }
    case 'sitemap.telemedicine':
      return { path: '/aboutservices', hash: '#telemedicine' }
    case 'sitemap.tpa':
      return { path: '/aboutservices', hash: '#tpa' }
    case 'sitemap.outpatientServ':
      return { path: '/aboutservices', hash: '#outpatientSer' }
    case 'sitemap.vaccinations':
      return { path: '/aboutservices', hash: '#vaccinations' }
    case 'sitemap.emergencyAss':
      return { path: '/aboutservices', hash: '#emergencyAss' }
    case 'sitemap.prodProc':
      return { path: '/aboutservices', hash: '#prodPro' }
    case 'sitemap.nursingServ':
      return { path: '/patinursing', hash: 'patinursing' }

    // workwithus
    case 'sitemap.joinOurNet':
      return { path: '/workwithus', hash: '#joinOur' }
    case 'sitemap.whythe':
      return { path: '/workwithus', hash: '#whyThe' }

    // bookyourappointment
    case 'sitemap.whatWePhone':
      return { path: '/bookyourappointment', hash: '#appointment' }

    case 'sitemap.doctorList':
      return { path: '/login', hash: '#login' }

    default:
      break;
  }
  return { path: '/aboutcorporate', hash: '#whatwedo' }
}
</script>

